import { useCallback } from 'react';

/**
 * Hook para manejar errores de API de forma consistente
 * Automáticamente maneja errores 401 (redirección al login)
 */
export const useApiErrorHandler = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleApiError = useCallback((error: any, customErrorHandler?: (error: any) => void) => {
    console.error('API Error:', error);

    // Si es un error 401, no hacer nada - el interceptor se encarga de la redirección
    if (error.response?.status === 401) {
      return;
    }

    // Si hay un manejador personalizado, usarlo
    if (customErrorHandler) {
      customErrorHandler(error);
      return;
    }

    // Para otros errores, simplemente logear
    console.error('Unhandled API error:', error);
  }, []);

  return { handleApiError };
};
